import Read from 'static/images/chat/read.svg';
import Received from 'static/images/chat/receivedMessage.svg';
import Sent from 'static/images/chat/sentMessage.svg';
import Pending from 'static/images/chat/pendingMessage.svg';

const getResourceTo = (resource) => Monet.I18n.getResourcesByKey(resource);

const changeAllDynamicAtt = (stringDynamicAtt = '') => (
  stringDynamicAtt.replace(/@(.*?)@/g, (_, defaultValue) => (
    getResourceTo(defaultValue)
  ))
);

const parseMessage = (messageData, origin) => {
  const messageBody = messageData;

  if (messageBody.to && (!Array.isArray(messageBody.to))) {
    messageBody.to = [messageBody.to];
  }

  if (messageBody.needTranslation) {
    messageBody.message = changeAllDynamicAtt(messageBody.message);
    messageBody.type = 'alert';
  }

  const {
    id,
    message,
    sentDate,
    type,
    from,
    fromName,
    readDate,
    receivedDate,
    needTranslation,
    ticketId = null
  } = messageBody;

  return {
    id,
    origin,
    from,
    fromName,
    type,
    text: message,
    sentDate: Monet.Format.DateTime.formatToLocale(sentDate),
    readDate,
    receivedDate,
    needTranslation,
    ticketId
  };
};

const parseMessageFromReassignedTicket = (messageData) => {
  const messageBody = messageData;

  if (messageBody.needTranslation) {
    messageBody.message = changeAllDynamicAtt(messageBody.message);
    messageBody.type = 'alert';
  }

  const {
    id,
    message,
    sentDate,
    type,
    from,
    fromName,
    ticketId = null,
    needTranslation
  } = messageBody;

  return {
    id,
    origin: 'external',
    from,
    fromName,
    type,
    text: message,
    sentDate: Monet.Format.DateTime.formatToLocale(sentDate),
    ticketId,
    isFromOtherAttendance: true,
    needTranslation
  };
};

const generateMobileUUID = (from) => {
  const now = new Date();

  return `${String(from)}-${now.getTime()}`;
};

const getStatusMessageIcon = (message) => {
  if (message.readDate) {
    return Read;
  }

  if (message.receivedDate) {
    return Received;
  }

  if (message.sentDate) {
    return Sent;
  }

  return Pending;
};

const parseUnreadMessagesToNewChats = async (messages) => {
  const newChats = {};

  const messagesToMarkAsReceived = messages.map(async (message) => {
    const { id, from, fromName } = message;
    const chatId = `${Monet.Session.User.id}-${from}`;
    const prefixedChatIdKey = `chatWindow_${chatId}`;
    const chatWindow = newChats[prefixedChatIdKey];

    const parsedMessage = parseMessage(message, 'external');

    if (!chatWindow) {
      newChats[prefixedChatIdKey] = {
        id: chatId,
        name: fromName || from,
        userName: fromName || from,
        closed: false,
        to: Monet.Session.User.id,
        from,
        messages: [parsedMessage]
      };
    } else {
      chatWindow.messages.push(parsedMessage);
    }

    return Monet.Session.Chat.Service.markMessageAsReceived({ messageId: id });
  });

  await Promise.all(messagesToMarkAsReceived);

  return newChats;
};

const triggerNewMessageAudio = () => {
  const audio = new Audio();
  // these source elements ensure fallback in case browser doesn't support .ogg audio format
  const sourceogg = document.createElement('source');
  const sourcemp3 = document.createElement('source');

  // eslint-disable-next-line
  sourceogg.setAttribute('src', require('static/sounds/bloop.ogg'));
  sourceogg.setAttribute('type', 'audio/ogg');
  // eslint-disable-next-line
  sourcemp3.setAttribute('src', require('static/sounds/bloop.mp3'));
  sourcemp3.setAttribute('type', 'audio/mpeg');

  audio.appendChild(sourceogg);
  audio.appendChild(sourcemp3);

  audio.play();
};

const encodeMessage = (message) => {
  const replacedMessage = message
    .replace(/\n/g, '')
    .replace(/\\/g, '\\\\')
    .replace(/"/g, "'");

  return encodeURIComponent(replacedMessage);
};

export {
  parseMessage,
  parseMessageFromReassignedTicket,
  getResourceTo,
  getStatusMessageIcon,
  generateMobileUUID,
  parseUnreadMessagesToNewChats,
  triggerNewMessageAudio,
  encodeMessage
};
